import React, {Component, Fragment} from 'react';
import {cloneDeep} from "lodash";
import {Col, Modal, Row, Input, Form, Upload, Button, Select, message, Table, Tooltip} from "antd";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import {ProjectOutlined, InboxOutlined, DeploymentUnitOutlined, SearchOutlined} from '@ant-design/icons';
import API from "../scripts/api";
import PaginationInfo from "../components/PaginationInfo";
import ReactToPrint from "react-to-print";
import { Constants } from '../scripts/settings';
import moment from "moment-jalaali";
class printRemainBarcodes extends Component {
    constructor() {
        super();
        this.state = {
            factor: [],
            newRow: [],
            orderItem: [],

        };
        this.barcodeRef = React.createRef();

    }
    //
    handleClick = () => {
        // React.useEffect(() => {
        //   this.barcodeRef.current.scrollTo(0, 0);
        // }, []);
        // if (this.barcodeRef.current) {
        //   this.barcodeRef.current.scrollIntoView();
        // }
        // setTimeout(() => {
        //   this.barcodeRef.current.scrollIntoView();
        // }, 600)

    }



    render() {
        const { barcodes } = this.props;

        return (
            <div>

            </div>

        );
    }
}


class RemainBarcodes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            Filter: '',
            FilterPacking: '',
            id: '',

            deletedBarcodes:[],
            barcodes:[],
            data:[],
            categories:[],
        };

        this.formRef = React.createRef();
        this.deleteBarcode = React.createRef();
    }


    handleSubmit = () => {
        let {publishRateArr} = this.state

    };

    handleWillUnmount = () => {
        // this.formRef.current.resetFields();
    };

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);
        console.log(!!cloneData.id);
        this.setState({editMode: !!cloneData.id, id: cloneData.id});
        if(!!cloneData.id){
            this.setState({barcodes: cloneData.range})
            this.getBarcodes(cloneData.id)
        }
    }

    getBarcodes = (params = {}) => {
        this.setState({ loading: true });
        API.printBarcode.productBarcodes(params)
            .then((result) => {
                if (result.data) {
                    this.setState({
                        loading: false,
                        data: result.data,
                        categories: result.categories,
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    handleFilter = (value) => {
        this.setState({ Filter: value });
        this.setState({ FilterPacking: "" });
    }

    handleFilterPacking = (value) => {
        this.setState({ Filter: "" });
        this.setState({ FilterPacking: value });
    }
    render() {
        const {onCancel, submitting, visible} = this.props;
        const { loading, data, Filter, FilterPacking, categories} = this.state;

        let totalCount = 0

        const SupportData = data.filter(o => {
            let query = false;
            let hasFilter = false;
            if (Filter) {
                hasFilter = true;
                if (o.barcode && o.barcode.indexOf(Filter) >= 0)
                    query = true;

            }
            if (FilterPacking) {
                hasFilter = true;
                if (o.package_count && o.package_count === FilterPacking)
                    query = true;
            }

            if (!hasFilter) {
                query = true;
            }
            return query;
        });

        let barcodesCount = 0

        categories && categories.length &&
        categories.map((item) => {
            let count = data.filter(function (element) {
                return element.package_count == item;
            }).length
            barcodesCount += item * count;
        })
        // let barcodesCount = SupportData.length
        const columns = [
            {
                title: Resources.barcode,
                dataIndex: "barcode",
                width: "30px",
            },

            {
                title: Resources.packing,
                dataIndex: "package_count",
                width: "30px",
            },

            {
                title: Resources.row,
                dataIndex: "row",
                width: "30px",
            },
            {
                title: Resources.identifier,
                dataIndex: "identifier",
                width: "30px",
            },
            {
                title: Resources.shelf,
                dataIndex: "shelf",
                width: "30px",
            },
             {
                            title: Resources.dateAndTime,
                            dataIndex: "created_at",
                            width: "30px",
                            render: (val) => moment(val).format(Constants.jDateTimeFormat),
                        },
            ];
        return (
            <Fragment>
                <Modal
                    title={ Resources.remainBarcodesList}
                    visible={visible}
                    onOk={this.handleSubmit}
                    onCancel={onCancel}
                    okText={Resources.confirm}
                    cancelText={Resources.cancel}
                    okButtonProps={{loading: submitting}}
                    cancelButtonProps={{disabled: submitting}}
                    footer={null}
                    width={1000}
                >
                    <div className="ant-content">

                        <Row gutter={24}>

                            <Col xs={24} md={6}>
                                <Tooltip title={Resources.searchHintUser}>
                                    <Input
                                        type="text"
                                        prefix={<SearchOutlined />}
                                        placeholder={Resources.barcode}
                                        onChange={({ target: { value } }) =>
                                            this.handleFilter(value, "filterSearch")
                                        }
                                        allowClear
                                    />
                                </Tooltip>
                            </Col>
                            <Col xs={24} md={6}>
                                <Tooltip title={Resources.searchHintUser}>
                                    <Input
                                        type="text"
                                        prefix={<SearchOutlined />}
                                        placeholder={Resources.packing}
                                        onChange={({ target: { value } }) =>
                                            this.handleFilterPacking(value, "filterSearch")
                                        }
                                        allowClear
                                    />
                                </Tooltip>
                            </Col>
                            <Col xs={24} md={6}>
                                <div >
                                    <span style={{color:"green"}}>{Resources.sumCounts}</span>:
                                    <span style={{margin:"5px"}}>{barcodesCount}</span>
                                </div>

                            </Col>
                            <Col xs={24} md={6}>
                                <div>
                                    <ReactToPrint
                                        trigger={() => (
                                            <button
                                                data-dismiss="modal"
                                                className="btn btn-none-box btn-info border-radius-lg border-md color-light"
                                            >
                                                پرینت
                                            </button>
                                        )}
                                        bodyClass="rtl"
                                        content={() => this.componentRef}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <hr />
                    <Row style={{marginTop: "10px"}} gutter={24}>
                        {
                            categories && categories.length &&
                            categories.map((item) => {
                                let count =  data.filter(function (element) {
                                    return element.package_count == item;
                                }).length
                                // totalCount +=   1;
                                return (<Col xs={24} md={6}>
                                    <span>{` ${count}  ${Resources.category}  ${item}  ${Resources.tay} `} </span> :
                                    <span style={{marginRight: "10px", color:"red"}}>{count * item}</span>
                                </Col>)

                            })
                        }
                    </Row>


                    <hr />
                    {/*<Row style={{textAlign:"center"}}>*/}
                    {/*    <span>{Resources.sumCounts}</span> :*/}
                    {/*    <span style={{marginRight: "10px", color:"red"}}>{totalCount}</span>*/}

                    {/*</Row>*/}
                    {/*<hr />*/}

                    <div className="ant-content">
                        <Table
                            columns={columns}
                            dataSource={SupportData}
                            loading={loading}
                            // onChange={this.handleTableChange}
                            pagination={false}

                            size="small"
                            rowKey="id"
                            ref={(el) => (this.componentRef = el)}
                            // scroll={{ x: 936 }}
                        />

                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export default RemainBarcodes;
